<template>
  <Bar :options="chartOptions" :data="chartData" />
</template>

<script setup>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Bar } from 'vue-chartjs'

const props = defineProps({
  options: Object,
  stacked: { type: Boolean, default: true } // اضافه شد
})

const isDark = document.documentElement.dataset.theme == 'dark';

ChartJS.defaults.font.family = 'iranyekanBakh,sans-serif';
ChartJS.defaults.color = isDark ? '#f3f4f6' : undefined;

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const COLORS = [
  '#EF4444','#F97316','#F59E0B','#84CC16','#22C55E','#10B981',
  '#14B8A6','#06B6D4','#0EA5E9','#3B82F6','#6366F1','#8B5CF6',
  '#A855F7','#D946EF','#EC4899','#F43F5E','#6B7280','#475569',
  '#0D9488','#15803D','#B91C1C','#78350F','#4338CA','#701A75',
  '#BE185D','#FACC15','#2563EB','#7C3AED','#059669','#DC2626'
]

const chartData = {
  labels: props.options.labels,
  datasets: props.options.datasets.map((item, idx) => ({
    ...item,
    backgroundColor: COLORS[idx % COLORS.length],
    tension: 0.2,
  }))
}

const chartOptions = {
  tooltip: {
    bodyColor: isDark ? '#f3f4f6' : undefined,
    backgroundColor: isDark ? '#1f2937' : undefined
  },
  scales: {
    x: {
      grid: { color: isDark ? '#374151' : undefined },
      ticks: { maxTicksLimit: 14, color: isDark ? '#f3f4f6' : undefined },
      stacked: props.stacked
    },
    y: {
      grid: { color: isDark ? '#374151' : undefined },
      ticks: { color: isDark ? '#f3f4f6' : undefined },
      stacked: props.stacked
    }
  },
  responsive: true,
  maintainAspectRatio: false
};
</script>
